import { ChangeEvent } from 'react';
import { AppState } from 'src/AppState/AppState';
import { MarketFeedPropsType } from 'src/domains/sportsbook/trading/view/eventDetails/markets/marketsSettings/components/marketFeed/MarketFeed';

export class MarketFeedState {

    constructor(readonly appState: AppState, readonly props: MarketFeedPropsType) {
    }

    onChangeUpdates = (event: ChangeEvent<HTMLInputElement>): void => {
        this.appState.eventStateActions.saveMarketChanges(this.props.marketId, {feedSettings: {updates: event.target.checked}});
    }

    onChangeResults = (event: ChangeEvent<HTMLInputElement>): void => {
        this.appState.eventStateActions.saveMarketChanges(this.props.marketId, {feedSettings: {results: event.target.checked}});
    }

    onChangePrices = (event: ChangeEvent<HTMLInputElement>): void => {
        this.appState.eventStateActions.saveMarketChanges(this.props.marketId, {feedSettings: {prices: event.target.checked}});
    }

    onChangeEachWay = (event: ChangeEvent<HTMLInputElement>): void => {
        this.appState.eventStateActions.saveMarketChanges(this.props.marketId, {feedSettings: {eachWay: event.target.checked}});
    }
}
